import React, { useEffect, useState } from 'react';
import { Col } from 'antd';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import LibraryLayout from 'components/Layouts/LibraryLayout';
import { RootState } from 'store/configureStore';
import { pageContent, gridConfig } from 'constants/libraryConstants';
import CardComponent from 'components/CardComponent';
import * as Styled from './Library.styled';

const Library: React.FC = () => {
  const { lang } = useSelector((state: RootState) => ({
    lang: state.global.lang
  }));
  const [, forceUpdate] = useState({});
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(lang).then(() => {
      forceUpdate({});
    });
  }, [lang]);

  return (
    <LibraryLayout>
      <Styled.Container>
        <Styled.StyledRow gutter={gridConfig.toolsGutter}>
          {pageContent.libraryTools.items.map((item) => (
            <Col
              key={item.key}
              xs={gridConfig.tools.xs}
              sm={gridConfig.tools.sm}
              md={gridConfig.tools.md}
              lg={gridConfig.tools.lg}
            >
              <CardComponent
                area={t(item.title)}
                infoText={t(item.description)}
                imgSrc=''
                className='library-card'
                href={item.href}
                textOnTop=''
              />
            </Col>
          ))}
        </Styled.StyledRow>
      </Styled.Container>
    </LibraryLayout>
  );
};

export default Library;
